import React from 'react';
import { Box, Card, CardContent, Tab, Tabs } from '@mui/material';
import TaskCommentsTab from './TaskCommentsTab';
import TaskHistoryTab from './TaskHistoryTab';
import TaskAttachmentsTab from './TaskAttachmentsTab';

function TabPanel({ children, value, index }) {
  if (value !== index) return null;
  return <Box sx={{ pt: 2 }}>{children}</Box>;
}

export default function TaskActivityTabsCard({
  tab,
  onTabChange,
  commentCount,
  historyCount,
  attachmentCount,
  commentsProps,
  history,
  attachmentsProps,
}) {
  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent sx={{ p: 0 }}>
        <Tabs
          value={tab}
          onChange={(_, next) => onTabChange(next)}
          sx={{
            px: 1,
            borderBottom: '1px solid',
            borderColor: 'divider',
            minHeight: 42,
            '& .MuiTab-root': {
              minHeight: 42,
              textTransform: 'none',
              fontSize: 12,
            },
          }}
        >
          <Tab label={`Comments (${commentCount})`} />
          <Tab label={`History (${historyCount})`} />
          <Tab label={`Task attachments (${attachmentCount})`} />
        </Tabs>

        <Box sx={{ p: 2 }}>
          <TabPanel value={tab} index={0}>
            <TaskCommentsTab {...commentsProps} />
          </TabPanel>

          <TabPanel value={tab} index={1}>
            <TaskHistoryTab history={history} />
          </TabPanel>

          <TabPanel value={tab} index={2}>
            <TaskAttachmentsTab {...attachmentsProps} />
          </TabPanel>
        </Box>
      </CardContent>
    </Card>
  );
}
